import { selectDefaultMapType } from 'bundles/connect/components/store/selectors/ui';
import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import { Form } from 'react-bootstrap-5';
import { useSelector } from 'react-redux';

type CustomMapTypeControlProps = {
  map: google.maps.Map | null;
}

export default function CustomMapTypeControl({ map }: CustomMapTypeControlProps) {
  const defaultMapType = useSelector(selectDefaultMapType);

  const [mapType, setMapType] = useState(defaultMapType);
  const [showTerrain, setShowTerrain] = useState(false);
  const [showLabels, setShowLabels] = useState(false);

  const handleTypeChange = (type: 'roadmap' | 'satellite' | 'hybrid' | 'terrain') => {
    setMapType(type);
    if (map) {
      map.setMapTypeId(type);
    }
  };

  return (
    <div
      className="position-relative d-flex flex-row p-1 rounded shadow"
      style={{
        backgroundColor: '#fff',
        bottom: 42,
        pointerEvents: 'auto'
      }}
    >
      <div className="btn-group rounded">
        <div
          style={{ position: 'relative', display: 'inline-block' }}
          onMouseEnter={() => setShowTerrain(true)}
          onMouseLeave={() => setShowTerrain(false)}
        >
          <Button
            className="rounded-end-0"
            variant={mapType === 'roadmap' || mapType === 'terrain' ? 'primary' : 'outline'}
            onClick={() => handleTypeChange('roadmap')}
          >
            Map
          </Button>
          {showTerrain && (
            <div className="position-absolute py-1 px-2 shadow rounded"
              style={{
                bottom: '100%',
                background: '#fff',
              }}
            >
              <Form.Check
                checked={mapType === 'terrain'}
                className="d-flex gap-1 align-items-center"
                id="terrain-checkbox"
                label="Terrain"
                type="checkbox"
                onChange={() => handleTypeChange(mapType === 'terrain' ? 'roadmap' : 'terrain')}
              />
            </div>
          )}
        </div>
        <div
          style={{ position: 'relative', display: 'inline-block' }}
          onMouseEnter={() => setShowLabels(true)}
          onMouseLeave={() => setShowLabels(false)}
        >
          <Button
            className="rounded-start-0"
            variant={mapType === 'satellite' || mapType === 'hybrid' ? 'primary' : 'outline'}
            onClick={() => handleTypeChange('satellite')}
          >
            Satellite
          </Button>
          {showLabels && (
            <div className="position-absolute py-1 px-2 shadow rounded"
              style={{
                bottom: '100%',
                background: '#fff',
              }}
            >
              <Form.Check
                checked={mapType === 'hybrid'}
                className="d-flex gap-1 align-items-center"
                id="labels-checkbox"
                label="Labels"
                type="checkbox"
                onChange={() => handleTypeChange(mapType === 'hybrid' ? 'satellite' : 'hybrid')}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );

}
